import { z } from 'zod';

export const languageSchema = z.object({
  EN: z.string(),
  ES: z.string(),
  PL: z.string(),
  PT: z.string(),
});
